// import $ from 'jquery';
import { gsap } from 'gsap';
import { debounce as _debounce } from 'underscore';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

// MOVE TO LIBS-HEAD.js
import 'jquery-clickout';

//---------- TOUCH EVENTS --------------------------------------//
//import '@benmajor/jquery-touch-events';

export default class{ // export class Layout
    
    constructor(options) {

    	// OPTIONS
        this.defaults = {
        	main: undefined,
        	skip_intro: false
        }

        this.options = {};
		Object.assign(this.options, this.defaults, options);
        this.namespace 	= 'layout';

		this.main 		= this.options.main;

        // VARS
		this.$window 	= $(window);
		this.$doc 		= $(document);
		this.$html 		= $('html');
		this.$body 		= $('body');

		this.init()

    }

 	init() {
 		
		this.debounceResize(true);
		this.initMainMenu();
		this.initMobile();
		this.initSearchDesktop();
		//this.initAlertBar();
		this.initSpecialLayouts();
		this.initScrollTo();

		setTimeout( ()=>{
			this.onResize();
		}, 100 );

		//console.log( 'initLayout' );
    }

    // -----------------------------------------------------------------[ RESIZE HANDLER ]--------------------------------------------------------------//
    debounceResize(b){
		if ( b ){
			// debounce resize
			this._debResize = _debounce( () => this.onResize(true), 17 );
			this.$window.on( 'resize', this._debResize );
			// Listen for orientation changes
			window.addEventListener("orientationchange", ()=> this.onOrientationChange(), false);
		}
		else{
			if ( this._debResize ){
				this._debResize.cancel();
				this.$window.off( 'resize', this._debResize );
			}        
			// Listen for orientation changes
			window.removeEventListener("orientationchange", ()=> this.onOrientationChange(), false);
		}
    }

    onOrientationChange(){
    	//console.log( 'onOrientationChange');
    	setTimeout( ()=>this.onResize(true), 77 );
    }

	onResize(b){

		// this class is used for layouts that need to be resized before revealed. For example .home-MAIN-promo (opacity=0 and resized opacity 1)
		this.$body.addClass( 'resized' );

		this.resizeMobilePanel();

	}

	resizeMobilePanel(){
		let mobileAvailheight  = window.innerHeight;

		$('#mobile-panel').height( mobileAvailheight );
		$('#mobile-panel .scroll-layer').height( mobileAvailheight - $( '#mobile-panel .row' ).height() );
	}

	initMainMenu(){
		let $main_navs = $('ul.nav-color.main');
		$main_navs.find(  'a' ).on( 'click', (e)=>this.setMainMenuCurrentSelection(e) );
		this.paintMenu();
	}

	initMobile(){
		$( '#burger' ).on( 'click', (e)=>{
			e.preventDefault();
			this.openMobilePanel( true );
		});
		$( '#close-mobile-panel' ).on( 'click', (e)=>{
			e.preventDefault();
			this.openMobilePanel( false );
		});
	}

	openMobilePanel(b){
		let $scroll = $( '#mobile-panel .scroll-layer' );
		if ( b ){
			this.$body.addClass( 'mobile-panel-open' );
			disableBodyScroll( $scroll[0] );
		}
		else{
			this.$body.removeClass( 'mobile-panel-open' );
			enableBodyScroll( $scroll[0] );
		}
	}

	/*
	initSearchDesktopBK(){
		let $search = $('.search-field'), $p;

		// empty search val
		$search.val( '' );

		$search.on( 'focus', (e)=>{
			this.openSearch( true, e );
		});

		$search.on( 'clickout', (e)=>{
			this.openSearch( false, e );
		});


		$search.on( 'mouseleave', (e)=>{
			this.openSearch( false, e );
			//$(e.target).blur();
		});
		$('.module-search-form').on( 'submit', (e)=>{
			$search = $(e.target).find( '.search-field' );
			if ( $search.val() === '' ){
				e.preventDefault();
				$search.focus();
			}
		});
	}
	openSearchBK( b, e ){
		let $search = $(e.target), 
			$p = $search.parents( '.dim-down' ), 
			$sitesearch_suggestion,
			is_open = $search.hasClass( 'open' );
		
		if ( b === is_open ){
			return;
		}

		//console.log( 'openSearch, b ' + b );

		if ( b ){
			if ( $p.length > 0 ){
				$p.addClass( 'search-open' );
			}
			$search.addClass( 'open' );
		}
		else{
			
			// if suggestion is open don't close
			$sitesearch_suggestion = $search.parents( 'form' ).find( '.unibox' );
			if ( $sitesearch_suggestion.length > 0 ){
				if ( $sitesearch_suggestion.hasClass( 'unibox--active' ) ){
					return;
				}
			}

			// close the field
			if ( $p.length > 0 ){
				$p.removeClass( 'search-open' );
			}
			
			$search.removeClass( 'open' );

			$search.val( '' );

			$search.blur();

		}
	}
	*/

	initSearchDesktop(){
		let $module = $( '.module-search-form:not(.inline)' ), 
			$search = $module.find('.search-field'), 
			$p;

		// empty search val
		setTimeout( ()=>{ $search.val( '' ); }, 77 );

		$module.on( 'click', (e)=>{
			this.openSearch( true, e );
		});

		$module.on( 'mouseleave', (e)=>{
			this.openSearch( false, e );
		});

		$module.find( '.search-submit' ).on( 'click', (e)=>{
			$p = $(e.currentTarget).parents( 'form' ).find( '.search-field' );
			if ( ! $p.hasClass( 'open' ) ){ 
				e.preventDefault();
				this.openSearch( true, e );
			}
			else{
			}
		})

		$module.find( 'form' ).on( 'submit', (e)=>{
			$search = $(e.target).find( '.search-field' );
			if ( $search.val() === '' ){
				e.preventDefault();
				$search.focus();
			}
		});
	}

	openSearch( b, e ){

		let $module = $(e.currentTarget);
		if ( !$module.hasClass( 'module-search-form' ) ){
			$module = $module.parents(  '.module-search-form' );
		}
		let $search = $module.find('.search-field'), 
			$p = $search.parents( '.dim-down' ), 
			$sitesearch_suggestion,
			is_open = $search.hasClass( 'open' );
		
		if ( b === is_open ){
			return;
		}

		//console.log( '_openSearch, b ' + b );
		
		if ( b ){
			if ( $p.length > 0 ){
				$p.addClass( 'search-open' );
			}
			$search.addClass( 'open' );
			$search.focus();
			
			$module.on( 'clickout', (e)=>{
				$(e.currentTarget).off( 'clickout' );
				this.openSearch( false, e );
			});

		}
		else{

			
			// if suggestion is open don't close
			$sitesearch_suggestion = $search.parents( 'form' ).find( '.unibox' );
			if ( $sitesearch_suggestion.length > 0 ){
				if ( $sitesearch_suggestion.hasClass( 'unibox--active' ) ){
					return;
				}
			}

			// close the field
			if ( $p.length > 0 ){
				$p.removeClass( 'search-open' );
			}
			
			$search.removeClass( 'open' );

			$search.val( '' );

			$search.blur();

		}
	}

	paintMenu(){

		//console.log( 'paintMenu' );

		// menu loaded trough barba
		let $p = $('#paint-menu'), 
		// main navigation (header + nav compact )
		$main_navs = $('ul.nav-color.main'),
		$ul, $li;

		$main_navs.each( (j,ul)=>{

			$ul = $(ul);

			$ul.find( 'li' ).each( (i,el) => {

				$li = $(el);

				// clear
				$li.removeClass( 'current-menu-item' ).removeClass( 'current-menu-parent' ).removeClass( 'current-menu-ancestor' );

				// check
				if ( 		$p.find( 'li' ).eq(i).hasClass( 'current-menu-item' ) 
						|| 	$p.find( 'li' ).eq(i).hasClass( 'current-menu-parent' ) 
						|| 	$p.find( 'li' ).eq(i).hasClass( 'current-menu-ancestor' )
						|| 	$p.find( 'li' ).eq(i).hasClass( 'current-page-parent' ) 
						|| 	$p.find( 'li' ).eq(i).hasClass( 'current-page-ancestor' )

				){
					$li.addClass( 'current-menu-item' );
				}
			} );

		} );

		this.paintMenuTemplate();
	}

	paintMenuTemplate(){
		if ( this.$body.hasClass( 'single-collection' ) ){
			this.setMenuSelection( 'collections' );
		}
		if ( this.$body.hasClass( 'single-item' ) ){
			this.setMenuSelection( 'collections' );
		}
		if ( this.$body.hasClass( 'single-preservation' ) ){
			this.setMenuSelection( 'preservation' );
		}
		if ( this.$body.hasClass( 'single-exhibition' ) ){
			this.setMenuSelection( 'digital exhibitions' );
		}
		if ( this.$body.hasClass( 'page-template-services-detail' ) || this.$body.hasClass( 'page-template-services-detail-simple' ) ){
			this.setMenuSelection( 'services' );
		}

		// collective access
		if ( this.$body.hasClass( 'collective-access' ) ){
			const path = location.pathname;
			if ( path.indexOf( 'Detail/collections' ) !== -1 ){
				this.setMenuSelection( 'collections' );
			}
			else if ( path.indexOf( 'Detail/objects' ) !== -1 ){
				this.setMenuSelection( 'watch' );
			}
		}

	}

	setMenuSelection(  which ){

		//console.log( which );
		let i = -1;
		switch( which ){ 
			case 'collections':
				i = 0;
			break;   
			case 'watch':
				i = 1;
			break;   
			case 'services':
				i = 2;
			break;   
			case 'preservation':
				i = 3;
			break;   
			case 'digital exhibitions':
				i = 4;
			break;   
		}
		if ( i !== -1 ){
			let $main_navs = $('ul.nav-color.main'), $ul, $li;

			$main_navs.each( (j,ul)=>{
				$ul = $(ul);
				$ul.find( 'li' ).each( (z,el) => {
					$li = $(el);
					// clear
					$li.removeClass( 'current-menu-item' ).removeClass( 'current-menu-parent' ).removeClass( 'current-menu-ancestor' );

					if ( z === i ){
						$li.addClass( 'current-menu-item' );
					}
				} );
			} );

		}
	}

	setMainMenuCurrentSelection(e){
		let $li = $(e.target).parent();
		$li.addClass( 'current-menu-item' );		
	}

	/*
	initAlertBar(){
		let $el = $( '.close-alert-bar' ), $bar;
		if ( $el.length > 0 ){
			
			$bar = $el.parents( '.alert-bar' );

			$el.on( 'click', (e)=>{
				e.preventDefault();

				gsap.to( $bar, {height:0,opacity:0,duration: 0.3,onComplete:()=>{
					$bar.remove();
					this.$window.trigger( 'resize' );
				}});

			});
		}
	}
	*/

	initSpecialLayouts(){
		let $el = $( 'section.secondary.services' ), $lis, $imgs;
		if (  $el.length > 0 ){
			$lis = $el.find( 'li' );
			$imgs = $el.find( '.img' );
			$lis.on( 'mouseenter', (e)=>{
				$lis.find('a').removeClass( 'selected' );
				$(e.currentTarget).find('a').addClass('selected');
				$imgs.removeClass( 'active' );
				$imgs.eq($(e.currentTarget).attr('data-index')).addClass( 'active' );
			});
		}
	}


	initScrollTo(){
		$('.scroll-to').on( 'click', (e)=>{
			
			e.preventDefault();

			let $el = $( $(e.currentTarget).attr('href') ), offset = $(e.currentTarget).attr('data-offset')?$(e.currentTarget).attr('data-offset'): 0;

			if ( $el.length > 0 ){
				this.scrollToHash( $el, offset , 0.1 );
			}

		} );
	}

	checkHashLink(e){
 		let hash, $a, $el, href, c;
		$a = $(e.currentTarget);
		href = $a.attr( 'href' );

        if ( href == '#' ) {
            return true;
        }

		if ( href.indexOf( '#' ) !== -1 ){
			c = href.split( '#' );
			hash = c[1];
		}
		$el = $( '#' + hash );

		// heck if element #hash exist and the link belong to  same page
		if ( $el.length > 0 && document.location.href.indexOf(c[0]) !== -1  ){
			e.preventDefault();

			// the offset is already defined in the html !!!

			//this.scrollToHash( $el, $a.attr( 'data-offset' )? parseInt($a.attr( 'data-offset' )) : false, 0.01 );
			this.scrollToHash( $el, 0.1, 0.01 );
			// document.location.hash = href.substring(1).replace( /-/g , ' ')
			// history.replaceState(null, null, document.location.pathname + '#' + hash );
		}
  	}

	scrollToHash( $el, offset, delay ){
 		gsap.to( $(window), {duration: 0.8, scrollTo: { y : $el[0], offsetY: offset?offset:0 }, delay: delay?delay:0.4, ease: 'power.easeOut' });
 	}

	
	onBarbaChangeState( state, data ){

		//console.log( state );

		switch ( state ){
			case 'before':
				break;
			case 'beforeEnter':
					this.paintMenu();
					this.initSpecialLayouts();
				break;
			case  'after':
				break;
		}
	}

	onOnceReady(){
		//this.paintMenu();
	}
}

